import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';

import { ADD_BOOK_TO_SHELF } from '@graphql/bookshelf';
import { Context } from '@store/store';
import AddBookToShelfIcon from '@icons/add-book-to-shelf-icon';

import { StyledAddBookToShelfButton } from './add-book-to-shelf-button.styles';

const AddBookToShelfButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);
  const [addBookToShelf, { data }] = useMutation(ADD_BOOK_TO_SHELF);

  return (
    <StyledAddBookToShelfButton
      title="Добавить документ на полку"
      onClick={() => {
        if (state.isUserLoggedIn) {
          addBookToShelf({ variables: { bookId: state.bookId } });
          dispatch({ type: 'SET_IS_ON_SHELF', payload: true });
          dispatch({ type: 'SHOW_SHELF_MODAL', payload: true });
        } else {
          dispatch({
            type: 'TOGGLE_LOGIN_MODAL_VISIBILITY',
            payload: true,
          });
          dispatch({ type: 'WOBBLE_LOGIN_MODAL', payload: true });
        }
      }}
    >
      <AddBookToShelfIcon
        width={isMobile ? 28 : 32}
        height={isMobile ? 22 : 25}
      />
    </StyledAddBookToShelfButton>
  );
};

export default AddBookToShelfButton;
